<template>
<div class="c-app flex-row content-center align-items-center">
  <CContainer >
    <CRow class="justify-content-center">
      <CCol md="12">
        <CCardGroup class="mt-5">
          <CCard class="p-4">
            <CCardBody>
              <form class="login" @submit.prevent="postLogin">
                <h2>Login</h2>
                <p class="text-muted">Sign In to your account</p>
                <CInput
                  placeholder="Username"
                  autocomplete="username email"
                  v-model="data.email" type="email"
                  required
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
                <CInput
                  placeholder="Password"
                  type="password"
                  autocomplete="curent-password"
                  v-model="data.password" 
                  required
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                  
                  
                </CInput>
                <CRow>
                  <CCol col="6" class="text-left">
                    <p class="text-danger" v-if="errors.invalid">{{ errors.invalid }}</p>
                    <CButton type="submit" color="info" class="px-4">Login</CButton>
                  </CCol>
                  <CCol col="6" class="text-right">
                     <CButton color="link"   class="px-0" @click="openReset"  >Forgot password?</CButton> 
                    
                  </CCol>
                </CRow>
              </form>
            </CCardBody>
          </CCard>
          <CCard
            color="loginpage"
            text-color="white"
            class="text-center py-4 d-sm-down-none"
            body-wrapper
          >
            

            
         
            <p class="mt-5" style="font-size:20px" > <em> "Where people are saved by grace, live by faith for the greater purposes of God." </em></p>
        <hr class="white-line">
         <h5 >IFGF Surabaya</h5>

          </CCard>
          
        </CCardGroup>
        <h3 class="mt-5">Verse of the Day</h3>
           
            <VueScriptComponent script='<script type="text/javascript">
            document.write("<iframe src=\"https://www.kingjamesbibleonline.org/popular-bible-verses-widget.php\" style=\"width: 350px; height: 100px; border:none  \"></iframe>");
            </script>'/>
      
      </CCol>
    </CRow>
    
  </CContainer>
</div>
  
</template>


<script >
import VueScriptComponent from 'vue-script-component'
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import axios from 'axios';
import EventBus from '@/eventBus';

import member from '@/services/member';
import alertmodal from '@/views/alert/modal.vue';
import store from '@/store.js'

document.write("<iframe src=\"popular-bible-verses-widget-nostyle.php\" style=\"width: 200px; height: 240px; border:none;\"></iframe>");

export default {

  getQuote(){
        return axios.get('https://www.kingjamesbibleonline.org/popular-bible-verses-widget.php')
            .then(response => {
                 this.datas =res
            })
    },

  components: { VueScriptComponent},
  name: 'Login',
  data(){
    return{
      datas:[],
            data: {
                id:'',
                email: '',
                password: '',
                remember_me: false
            }
    }
  },
    created() {
        if (this.isAuth) {
            this.$router.push('/')
        }
    },
    mounted(){
    this.load()
  },
    computed: {
        ...mapGetters(['isAuth']),
        ...mapState(['errors'])
    },
    methods: {
        ...mapActions('auth', ['submit']),
        ...mapActions('user', ['getUserLogin']),
        ...mapMutations(['CLEAR_ERRORS']),
        postLogin() {
            this.submit(this.data).then(() => {
                if (this.isAuth) {
                    this.CLEAR_ERRORS()
                    this.$router.push('/')
                }
            })
        },
        
    //   handleResetPassword(uuid,id) {
    //   //SET PERMISSION EACH FEATURE
    
    //   if(confirm("Do you really want to reset password?")){
    //     member.resetpassword(id)
    //     .then(res => {
    //       EventBus.$emit('TABLE_UPDATE', true)
    //       var params = {title: 'Success', mode:'success', data:res.message}
    //       EventBus.$emit('OPEN_MODAL_ALERT', params)
    //     }).catch ((err) => {
    //       var params = {title: 'Error', mode:'danger', data:err.response.data.message}
    //       EventBus.$emit('OPEN_MODAL_ALERT', params)
    //     })
       
    //   }   
     
      
    //   //SET END    
    // },    

        openReset(id){  
         
         this.$router.push({name:'Forgot Password'}) 
                    
    },

    //     openReset(id){  
    //     member.resetpassword(id)
    //     .then(res => {
    //       EventBus.$emit('TABLE_UPDATE', true)
    //       var params = {title: 'Success', mode:'success', data:res.message}
    //       this.$router.push({name:'Reset Password',query: {id:id} }) 
           
    //     }).catch ((err) => {
    //       var params = {title: 'Error', mode:'danger', data:err.response.data.message}
    //       EventBus.$emit('OPEN_MODAL_ALERT', params)
    //     })
          
        
    // },
    },
    destroyed() {
        this.getUserLogin()
    }
}


</script>
